import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import Heading from "@amzn/meridian/heading";
import {FormattedMessage} from "react-intl";

export const ErrorPageView = (props) => {
    return (
        <Column spacingInset="large">
            <Link type="secondary" onClick={props.history.goBack}>
                <FormattedMessage id="search.error.go_back" defaultMessage="Go Back"/>
            </Link>
            <Row>
                <Heading level={1}><FormattedMessage id="search.error.unknown" defaultMessage="Unknown"/> {props.entityType} {props.entityId}</Heading>
            </Row>
        </Column>
    );
}


// WEBPACK FOOTER //
// ./src/components/detailPages/ErrorPageView.js